import { useState, useCallback } from "react";
import { Check, Copy } from "lucide-react";

interface CopyMessageButtonProps {
  content: string;
}

export function CopyMessageButton({ content }: CopyMessageButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(content).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }, [content]);

  return (
    <button
      onClick={handleCopy}
      className="rounded-md p-1 text-daydra-muted/40 hover:text-daydra-dim transition-colors"
      aria-label="Copy message"
    >
      {copied ? (
        <Check size={12} className="text-daydra-success/60" />
      ) : (
        <Copy size={12} />
      )}
    </button>
  );
}
